module.exports = __webpack_public_path__ + "img/7.980aa400.jpg";